import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { isLoading, isNormal, useStatus, useData } from 'resift';
import getRoles from 'fetches/rolesAndPermissions/getRoles';

import CircularProgress from '@material-ui/core/CircularProgress';
import RoleConfiguration from './RoleConfiguration';

function Container() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const status = useStatus(getRoles);
  const rolesData = useData(getRoles);

  useEffect(() => {
    if (!rolesData) {
      dispatch(getRoles({ expandMemberCount: true }));
    }
  }, []);

  if (isLoading(status)) {
    return <CircularProgress color="secondary" className={classes.loading} />;
  }

  if (!isNormal(status)) {
    return <div>Something went wrong.</div>;
  }

  return <RoleConfiguration status={status} />;
}

const useStyles = makeStyles(theme => ({
  root: {},
  loading: {
    display: 'flex',
    margin: 'auto',
  },
}));

export default Container;
